/**
 * Build-environment feature gates.
 *
 * `SHOW_TEST_TOOLS` guards TEST/DEV-only affordances that must NEVER reach real
 * users of the production client build — e.g. the Proposals "New test proposal"
 * seeder, a scaffold that exists only until the agent-loop authors proposals for
 * real. Keeping the predicate in one place means every such control gates on the
 * same rule instead of each screen inventing its own check.
 *
 * The rule: surface test tools only on the dev server (`import.meta.env.DEV`), or
 * when a deploy explicitly opts in via a truthy `VITE_ENABLE_TEST_TOOLS`. The
 * production build leaves the flag off (see web/.env.production), so the live
 * product hides them; a staging deploy can flip the env var to test the flow.
 */

/** Truthy per the same "1"/"true" convention as VITE_USE_MOCK (useMock()). */
function truthy(v: unknown): boolean {
  return v === "1" || v === "true" || v === true;
}

/** Pure predicate, unit-testable without touching real `import.meta.env`. */
export function computeShowTestTools(env: {
  DEV?: boolean;
  VITE_ENABLE_TEST_TOOLS?: unknown;
}): boolean {
  return Boolean(env.DEV) || truthy(env.VITE_ENABLE_TEST_TOOLS);
}

export const SHOW_TEST_TOOLS: boolean = computeShowTestTools(
  (import.meta.env ?? {}) as {
    DEV?: boolean;
    VITE_ENABLE_TEST_TOOLS?: unknown;
  },
);
